/* ==========================================================================
   BAAGHI — facets.js
   Storefront filtering & sorting with History API + partial section render
   ========================================================================== */
(function () {
  'use strict';

  const container = document.querySelector('[data-facets-container]');
  if (!container) return;

  const sectionId = container.getAttribute('data-facets-section');
  let debounceTimer;

  function setLoading(state) {
    const grid = document.querySelector('[data-product-grid]');
    if (grid) grid.style.opacity = state ? '0.4' : '';
  }

  function renderFrom(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');

    ['[data-product-grid-wrapper]', '[data-facets-form-desktop]', '[data-facets-form-mobile]', '[data-active-facets]', '[data-facets-count]'].forEach(
      (selector) => {
        const incoming = doc.querySelector(selector);
        const current = document.querySelector(selector);
        if (incoming && current) current.innerHTML = incoming.innerHTML;
      }
    );

    if (window.BAAGHI.observeReveals) window.BAAGHI.observeReveals(document);
    setLoading(false);
  }

  function fetchAndRender(searchParams, updateHistory) {
    setLoading(true);
    const url = `${window.location.pathname}?${searchParams}`;

    fetch(`${url}${searchParams ? '&' : ''}section_id=${sectionId}`)
      .then((res) => res.text())
      .then((text) => {
        renderFrom(text);
        if (updateHistory !== false) window.history.pushState({ searchParams }, '', url);
      })
      .catch(() => {
        window.location.href = url;
      });
  }

  function paramsFromForms() {
    const params = new URLSearchParams();
    const seen = new Set();

    document.querySelectorAll('[data-facets-form] input, [data-facets-form] select').forEach((field) => {
      if (!field.name) return;
      if (field.type === 'checkbox' || field.type === 'radio') {
        if (!field.checked) return;
      }
      if (field.value === '') return;
      const key = `${field.name}=${field.value}`;
      if (seen.has(key)) return;
      seen.add(key);
      params.append(field.name, field.value);
    });

    return params.toString();
  }

  container.addEventListener('change', (event) => {
    if (!event.target.closest('[data-facets-form]')) return;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => fetchAndRender(paramsFromForms()), 180);
  });

  container.addEventListener('submit', (event) => {
    if (!event.target.closest('[data-facets-form]')) return;
    event.preventDefault();
    fetchAndRender(paramsFromForms());
  });

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-facet-remove]');
    if (!link) return;
    event.preventDefault();
    const url = new URL(link.href);
    fetchAndRender(url.searchParams.toString());
    if (window.innerWidth < 990) window.BAAGHI.Drawer.close('FacetsDrawer');
  });

  document.addEventListener('change', (event) => {
    const sort = event.target.closest('[data-sort-by]');
    if (!sort) return;
    const params = new URLSearchParams(window.location.search);
    params.set('sort_by', sort.value);
    fetchAndRender(params.toString());
  });

  window.addEventListener('popstate', (event) => {
    const searchParams = (event.state && event.state.searchParams) || '';
    fetchAndRender(searchParams, false);
  });
})();
